export const backend = "https://tka-hotline.kemnaker.go.id:4444"; // ubah di sini saja
//export const websocket = "https://tka-hotline.kemnaker.go.id:444";
export const websocket = "https://tka-hotline.kemnaker.go.id:445";